export const ROUTES = {
  VERIFY_EMAIL: '/verify-email/:token'
};